import { Component } from "react";
import PropTypes from "prop-types";
import { LoggedError } from "../../../../services/errors";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error, info) {
    throw new LoggedError(error, LoggedError.error, info);
  }

  render() {
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary;
